export const annexesConstants = {
    GET_ANNEXES: "GET_ANNEXES",
    GET_ANNEXE: "GET_ANNEXE",
  };
  